import { Pipe, PipeTransform } from '@angular/core';
import { AnalyticalPlanAndSections } from 'src/app/_shared/stores/analytical-plan/analytical-plan.state';
import { CleRepartitionModelDto } from 'src/graphql/generated-types';

import { formatPercent } from '@angular/common';
import { arrayEmpty } from 'src/app/utils/array.utils';

@Pipe({
    name: 'repartitionKeyLabel',
    standalone: false
})
export class RepartitionKeyLabelPipe implements PipeTransform {

    static format(repartitionKey: CleRepartitionModelDto, plansList: AnalyticalPlanAndSections[]): string {
        if(!repartitionKey || arrayEmpty(plansList)){
            return '-';
        }

        const planAndSections = plansList.find(e => e.plan.Id === repartitionKey.IdPlanAnalytique);
        const section = planAndSections?.sections?.find(e => e.Id === repartitionKey.IdSectionAnalytique) || {};
        const valuesList = [section.Libelle, formatPercent(repartitionKey.Pourcentage, 'fr-FR')];
        if (plansList.length > 1) {
            valuesList.splice(0, 0, planAndSections.plan.Libelle);
        }

        return valuesList.filter(e => !!e).join(' - ');
    }

    transform(repartitionKey: CleRepartitionModelDto, plansList: AnalyticalPlanAndSections[]): string {
        return RepartitionKeyLabelPipe.format(repartitionKey, plansList);
    }
}
